import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

    instrumentTypeStatus: "",
    productsStatus: "",
    approximateStatus: "",

    isInstrumentTypeEnabled: false,
    isProductsEnabled: false,
    isApproximateEnabled: false,


    active_item:0,
    selected_categoryID:0,
    selected_instrumentType:"",
    selected_instrumentTypeID:0,
    selected_productGroup:"",
    view_product_result:"",

    updateRate:"",
    acqusitionRate:"",
    powerType:"",
    operatingCondition:"",
    temperature:"",
    temperatureValue:0,

    showDisclaimer:false

  }
})